import { Modal as JoyModal, ModalProps } from '@mui/joy'
import { EditModeProvider } from 'listings/editMode'

export const dontCloseOnBackgroundClick = (onClose: () => void) => (event, reason) => {
    if (reason === 'backdropClick') {
        return
    }
    onClose()
}

export default function Modal({ children, ...props }: ModalProps) {
    return (
        <EditModeProvider defaultEdit={true}>
            <JoyModal {...props}>{children}</JoyModal>
        </EditModeProvider>
    )
}
